import { Filmography } from 'layouts';
import { FilmographyIndexPropTypes } from 'layouts/Filmography';
import { AllVideos } from 'layouts/Filmography/Filmography';
import { getAllVideoCategories } from 'lib/api/videoCategories';
import { getAllVideos, getFeaturedReel } from 'lib/api/videos';
import { VideoMeta } from 'types/media';

export const getStaticProps = async (): Promise<{ props: FilmographyIndexPropTypes }> => {
    const videos = getAllVideos();

    const formatVideo = (video: any): VideoMeta => ({
        title: video.title,
        desc: video.desc,
        videoLink: video.videoLink,
        previewImage: {
            url: video.previewImage,
        },
    });

    const categories = getAllVideoCategories()
        .map((cat) => cat.name as string)
        .sort();

    const defaultValue = categories.reduce((prev: AllVideos, key) => {
        prev[key] = [];
        return prev;
    }, {});

    const sortedVideos: AllVideos = videos.reduce((prev, video) => {
        const categoryKey = video.categories[0].toUpperCase();
        prev[categoryKey].push(formatVideo(video));

        return prev;
    }, defaultValue);

    const featuredVideo = getFeaturedReel();

    return {
        props: {
            featuredVideo,
            videos: sortedVideos,
            keys: categories,
        },
    };
};

export default Filmography;
